import erreurSrc from '~/src/assets/illustrations/erreur.png';
import I18n from '~/src/common/services/I18n';

import * as S from './layout';

interface Props {
  term: string;
}

const Empty = ({ term }: Props) => (
  <S.Container>
    <S.Image src={erreurSrc} />
    <S.Content>
      {I18n.t('search.results.status.empty.line1')}
      <S.Term>{term}</S.Term>
      <S.Dot>. </S.Dot>
      {I18n.t('search.results.status.empty.line2')}
    </S.Content>
  </S.Container>
);

export default Empty;
